import { Lexer, type Token } from "marked";

/**
 * Keep prose line spacing when moving between textareas, Markdown editors and
 * message views. Leave lists, tables, code and other block syntax unchanged.
 */
export function preserveMarkdownLineBreaks(markdown: string): string {
  const tokens = Lexer.lex(markdown.replace(/\r\n?/g, "\n"), { gfm: true, breaks: true });
  return tokens.map((token, index) => {
    if (token.type === "paragraph") {
      return preserveInlineBreaks(token.raw);
    }
    if (token.type === "space"
      && tokens[index - 1]?.type === "paragraph"
      && tokens[index + 1]?.type === "paragraph") {
      return token.raw.replace(/\n/g, "\\\n");
    }
    return token.raw;
  }).join("");
}

function preserveInlineBreaks(text: string): string {
  return Lexer.lexInline(text, { gfm: true, breaks: true }).map((token: Token) => {
    if (token.type === "br") {
      return "\\\n";
    }
    // Recurse into formatting without rewriting code spans, URLs or HTML.
    if (token.type === "strong" || token.type === "em" || token.type === "del") {
      const delimiterLength = token.type === "em"
        || (token.type === "del" && !token.raw.startsWith("~~")) ? 1 : 2;
      return token.raw.slice(0, delimiterLength)
        + preserveInlineBreaks(token.raw.slice(delimiterLength, -delimiterLength))
        + token.raw.slice(-delimiterLength);
    }
    return token.raw;
  }).join("");
}
